import React from "react";

const MainLogo = () => {
  return (
    <div className="logo-component">
      {/* <img src="/images/logos/brand-bards-logo-2x.png" alt="BrandBards" /> */}
      <img src="/images/logos/propertylogy_logo.svg" alt="BrandBards" />
    </div>
  );
};

export default MainLogo;
